module.exports = __webpack_public_path__ + "static/media/ontology-icon-640.f2320c81.png";